// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\OpeningHourExceptionSearchResponse

import { hydrateOpeningHourException, type OpeningHourException, type OpeningHourExceptionApiResponse } from './openingHourException.gen';

export type OpeningHourExceptionSearchApiResponse = {
	items: OpeningHourExceptionApiResponse[];
};

export type OpeningHourExceptionSearch = {
	items: OpeningHourException[];
};

export function hydrateOpeningHourExceptionSearch(data: OpeningHourExceptionSearchApiResponse): OpeningHourExceptionSearch {
	return {
		...data,
		items: data.items.map(hydrateOpeningHourException),
	};
}